/* VolpicelliART redesign: click a picture to see it big; 'Up close' shows the close-up photo; click the picture to zoom to the file's real pixels.
   Right-click on any drawing takes you to that piece (or to the prints) instead of the browser menu. */
(function(){
  var PRINTS='/collections/original-art-prints';
  var box,img,cap,link,tog,zoomed=false,cur=null,showingDetail=false;
  function build(){
    box=document.createElement('div'); box.className='vp-lb';
    box.innerHTML="<button type='button' class='vp-lb__close' aria-label='Close'>&times;</button><div class='vp-lb__scroll'><img class='vp-lb__img' alt='' draggable='false'></div><div class='vp-lb__bar'><span class='vp-lb__cap'></span><button type='button' class='vp-lb__toggle'>Up close</button><span class='vp-lb__hint'>Click the picture to zoom. Scroll to move around.</span><a class='vp-btn vp-lb__link' href='#'></a><span class='vp-lb__credit'>&copy; Michael Volpicelli</span></div>";
    document.body.appendChild(box);
    img=box.querySelector('.vp-lb__img'); cap=box.querySelector('.vp-lb__cap'); link=box.querySelector('.vp-lb__link'); tog=box.querySelector('.vp-lb__toggle');
    box.querySelector('.vp-lb__close').addEventListener('click',close);
    box.addEventListener('click',function(e){ if(e.target===box||e.target.classList.contains('vp-lb__scroll')) close(); });
    box.addEventListener('contextmenu',function(e){ e.preventDefault(); goTo(cur); });
    img.addEventListener('click',function(){ setZoom(!zoomed); });
    tog.addEventListener('click',function(){ show(!showingDetail); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
  }
  function goTo(a){ var l=(a&&a.getAttribute('data-link'))||PRINTS; window.location.href=l; }
  function setZoom(on){
    zoomed=on; box.classList.toggle('is-zoomed',on);
    if(on){ var nat=img.naturalWidth||1600; var w=Math.max(window.innerWidth, Math.min(nat, window.innerWidth*3)); img.style.width=w+'px'; }
    else { img.style.width=''; }
  }
  function show(detail){
    showingDetail=detail; setZoom(false);
    var src=detail&&cur.getAttribute('data-detail') ? cur.getAttribute('data-detail') : cur.getAttribute('href');
    img.src=src; tog.textContent=detail?'Whole picture':'Up close';
    cap.textContent=(cur.getAttribute('data-caption')||'')+(detail?', up close':'');
  }
  function open(a){
    if(!box) build(); cur=a;
    var l=a.getAttribute('data-link');
    if(l){ link.href=l; link.textContent=a.getAttribute('data-link-label')||'See it'; link.style.display='inline-block'; } else { link.style.display='none'; }
    tog.style.display=a.getAttribute('data-detail')?'inline-block':'none';
    show(false);
    box.classList.add('is-open'); document.body.style.overflow='hidden';
  }
  function close(){ if(!box) return; box.classList.remove('is-open'); document.body.style.overflow=''; }
  document.addEventListener('click',function(e){
    var a=e.target.closest ? e.target.closest('a.vp-zoom') : null;
    if(!a) return; e.preventDefault(); open(a);
  });
  document.addEventListener('contextmenu',function(e){
    var a=e.target.closest ? e.target.closest('a.vp-zoom') : null;
    if(a){ e.preventDefault(); goTo(a); return; }
    var m=e.target.closest ? e.target.closest('.media img, .product__media img, .card__media img') : null;
    if(m){ e.preventDefault(); window.location.href=PRINTS; }
  });
})();
